import { render, staticRenderFns } from "./RoleModify.vue?vue&type=template&id=55a6605d&scoped=true&"
import script from "./RoleModify.vue?vue&type=script&lang=js&"
export * from "./RoleModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6605d",
  null
  
)

export default component.exports